<template>
  <div class="w-full px-4">
    <div>
      <div v-if="!isMobile"
           data-style-title
           class="mt-6">
        <p class="font-bold">{{ $t('message.builder.petPortraits.styles.heading') }}</p>
      </div>
      <div class="flex md:ml-0 md:mt-2 overflow-x-auto overflow-y-hidden" role="listbox">
        <Option
            v-for="(styleObject, index) in petPortraitStyles"
            :key="styleObject.code"
            :selected="selectedPetPortraitStyle === styleObject.code"
            @click="handleSelectStyle(styleObject.code)"
            :data-wd-id="`color-${index}`"
            :image="require('@vuedir/assets/styles/PP/Square_' + index + '.jpg')"
            data-test-id="filter-none"
            :heading="styleObject.label"
            compact
            :class="index === 0 ? '' : 'ml-4 md:ml-0'"
        />
      </div>
    </div>
    <div v-if="selectedPetPortraitStyle !== 'sketch2'" data-color-options>
      <div v-if="!isMobile"
           data-color-title
           class="mt-3">
        <p class="font-bold">{{ $t('message.builder.petPortraits.colors.heading') }}</p>
      </div>
      <div class="flex md:flex-wrap mt-4 md:w-full md:ml-0 md:mt-2 overflow-x-auto overflow-y-hidden" role="listbox">
        <Option
            v-for="(colorObject, index) in filteredPetPortraitColors"
            :key="colorObject.code"
            :selected="selectedPetPortraitColor === colorObject.code"
            @click="handleSelectColor(colorObject.code)"
            :data-wd-id="`color-${index}`"
            data-test-id="filter-none"
            :heading="colorObject.label"
            compact
            :aria-hidden="false"
            :color="colorObject.code === 'custom' ? selectedPetPortraitColor : index"
            :class="index === Object.keys(petPortraitColors)[0] ? '' : 'ml-4 md:ml-0'"
        />
        <div :class="colorPickerClassList">
          <label for="colorPicker"
                 :style="colorPickerStyleList"
                 class="relative w-24 h-24 md:w-20 md:h-20 md:w-20 md:h-20 lg:w-24 lg:h-24 xl:w-20 xl:h-20"></label>
          <input id="colorPicker"
                 class="opacity-0 absolute bottom-0 right-0"
                 style="z-index: -1000;"
                 v-if="selectedPetPortraitColor"
                 ref="colorPicker"
                 type="color"
                 :value="selectedPetPortraitColor"
                 @change="handleSelectCustomColor" />
          <div class="pt-2 md:pt-0 md:px-0 md:pt-1">
            <div class="font-bold text-sm leading-none mt-1">Custom</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Option from '@vuedir/components/Option'

/**
 * Styles.vue
 *
 */
export default {
  components: {
    Option
  },

  props: {
    petPortraitStyles: {
      type: Array
    },
    petPortraitColors: {
      type: Object
    },
    selectedPetPortraitStyle: {
      type: String
    },
    selectedPetPortraitColor: {
      type: String
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {

    }
  },

  computed: {
    filteredPetPortraitColors () {

      return Object.fromEntries(Object.entries(this.petPortraitColors).filter(([key]) => !key.includes('custom')))
    },
    colorPickerClassList () {
      return [
          'flex flex-col cursor-pointer relative md:mb-4 md:w-1/3 xl:w-1/4 ml-4 md:ml-0',
      ]
    },
    colorPickerStyleList () {
      return 'background-color:' + this.selectedPetPortraitColor
    }
  },

  methods: {
    handleSelectStyle (style) {
      this.$emit('changeStyle', style)
    },

    handleSelectColor (color) {
      this.$emit('changeColor', color)
    },

    handleSelectCustomColor (event) {
      this.handleSelectColor(event.target.value)
    },
  },
}
</script>
